import React from 'react';
import { SHELL, MAX } from './styles';

/** Centered "Loading…" / error message used as a placeholder. */
export function ShellMessage({ children }) {
  return (
    <div style={SHELL}>
      <div style={{ ...MAX, padding: '60px 20px', textAlign: 'center', color: '#64748b' }}>
        {children}
      </div>
    </div>
  );
}

/** Two-column label/value row used in receipts + checkout summaries. */
export function Row({ label, children, muted }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 13 }}>
      <span style={{ color: '#64748b' }}>{label}</span>
      <span style={{ color: muted ? '#94a3b8' : '#0f172a' }}>{children}</span>
    </div>
  );
}

/** Stacked label + control used in forms. */
export function Field({ label, children }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 12, color: '#64748b', fontWeight: 600, marginBottom: 4 }}>{label}</div>
      {children}
    </div>
  );
}
